export const VotingConstants = {
	SET_ACTIVE_ITEM: "SET_ACTIVE_ITEM",

	GET_ALL_VOTING: "GET_ALL_VOTING",
	GET_ALL_VOTING_SUCCESS: "GET_ALL_VOTING_SUCCESS",

	GET_ONE_VOTING: "GET_ONE_VOTING",
	GET_ONE_VOTING_SUCCESS: "GET_ONE_VOTING_SUCCESS",

	LOADING_ADDRESSES: "LOADING_ADDRESSES",
	GET_ADDRESSES_BY_COMPANY: "GET_ADDRESSES_BY_COMPANY",
	GET_RAW_ADDRESSES: "GET_RAW_ADDRESSES",

	CONTROL_MODAL: "CONTROL_MODAL",

	GET_VOTING_RESULTS: "GET_VOTING_RESULTS",
	GET_VOTING_RESULTS_SUCCESS: "GET_VOTING_RESULTS_SUCCESS",

	GET_VOTING_OTHER_RESULTS: "GET_VOTING_OTHER_RESULTS",
	GET_VOTING_OTHER_RESULTS_SUCCESS: "GET_VOTING_OTHER_RESULTS_SUCCESS",

	VOTING_DELETING: "VOTING_DELETING",
	VOTING_DELETED: "VOTING_DELETED",

	ITEM_LOADING: "ITEM_LOADING",
	ITEM_LOADED: "ITEM_LOADED",
};
